import React from 'react';
import useReactTable from '../../../../../hooks/common/useReactTable';
import {
  CS_REVIEW_LIST_FILTER_OPTION_MODEL,
  CS_REVIEW_LIST_PAGINATION_MODEL,
  CS_REVIEW_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/cs/review/models';
import { useFetchReviewsQuery } from '../../../../cs/review/common/hook/queries/useFetchReviewsQuery';
import useReviewListExcelDownload from '../../../../cs/review/common/hook/queries/useReviewListExcelDownload';
import CsReviewList from '../../../../cs/review/list/CsReviewList';
import { asyncSimpleModal } from '../../../../../lib/common';
import toastMsg from '../../../../../lib/toastMsg';
import FullscreenLoader from '../../../../../components/base/FullscreenLoader';
import { extractErrorMessage } from '../../../../../lib/utils/checkErrorResponse';

const AccountUserDetailCsReviewInfo = (props) => {
  const { userId, isActive } = props;

  const {
    filterOption,
    paginationOption,
    sortOption,
    handleChangeFilterOption,
    handleChangePaginationOption,
    handleClickSortOption,
    handleClickResetFilter,
    currentPage,
    setCurrentPage,
    handleDateRangeChange,
  } = useReactTable({
    filterOptionModel: {
      ...CS_REVIEW_LIST_FILTER_OPTION_MODEL,
      userId,
    },
    sortOptionModel: CS_REVIEW_LIST_SORT_OPTION_MODEL,
    paginationModel: CS_REVIEW_LIST_PAGINATION_MODEL,
  });

  const { data: reviewList, isLoading } = useFetchReviewsQuery({
    params: {
      page: Math.max(paginationOption.pageIndex, 1),
      pageSize: Math.max(paginationOption.pageSize, 100),
      ...filterOption,
      ...sortOption,
    },
    options: {
      enabled: !!userId && isActive,
    },
  });

  const { mutateAsync } = useReviewListExcelDownload();

  const handleExcelDownload = async () => {
    try {
      const response = await mutateAsync({
        ...filterOption,
        ...sortOption,
      });
      if (response && response.adminEmail) {
        asyncSimpleModal({
          type: 'success',
          title: '엑셀 파일 요청 완료',
          message: `${response.adminEmail}로 엑셀파일을 받을 수 있는 링크를 전송하였습니다. 파일 크기에 따라 이메일 발송이 몇 분 소요될 수 있습니다.`,
        });
      }
    } catch (error) {
      toastMsg.error(extractErrorMessage(error));
    }
  };

  if (isLoading) {
    return <FullscreenLoader visible={true} />;
  }

  return (
    <div className="account-user-detail-content">
      <div className="account-user-detail-section">
        <div className="title">상품 후기 리스트</div>
        <CsReviewList
          reviewList={reviewList}
          onChangeFilterOption={handleChangeFilterOption}
          onClickResetFilter={handleClickResetFilter}
          onChangePaginationOption={handleChangePaginationOption}
          onClickExcelDownload={handleExcelDownload}
          onClickSortOption={handleClickSortOption}
          onClickDateRangeChange={handleDateRangeChange}
          paginationOption={paginationOption}
          sortOption={sortOption}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default AccountUserDetailCsReviewInfo;
